/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantOrgCapabilitiesVcdr } from './tenantOrgCapabilitiesVcdr';


export interface VcdrTenantProperties { 
    capabilities?: TenantOrgCapabilitiesVcdr;
    erp_id?: string;
    org_id: string;
    org_name?: string;
    org_type?: string;
    restricted?: boolean;
    /**
     * True if VCF OAuth app is available else False.
     */
    vcf_oauth_app_available?: boolean;
    /**
     * True if VMC OAuth app is available else False.
     */
    vmc_oauth_app_available?: boolean;
}

